import axios from 'axios';
import { env } from '../../config/env';

/** Cliente axios base con la URL del API Dicio. */
export const apiClient = axios.create({
  baseURL: env.apiUrl,
});

/** Genera headers estándar para peticiones autenticadas. */
export function buildHeaders(
  apikey: string,
  uuidTrx: string,
  uuidCliente: string,
  contentType: 'json' | 'form-data' = 'json',
): Record<string, string> {
  return {
    'Content-Type': contentType === 'json' ? 'application/json' : 'multipart/form-data',
    transaccion:    uuidTrx,
    cliente:        uuidCliente,
    apikey,
  };
}
